import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import React from "react";
import { FetchShiftsResponse } from "store/reducers";

import { AllowanceSummary } from "../components/AllowanceSummary";
import { OrdinaryHoursSummary, WeekendHoursSummary } from "../components/WorkedHoursSummary";
import { Duration } from "./table_components/duration";

type Props = {
  workedShiftData: FetchShiftsResponse | undefined;
};

export function TimesheetSummary(props: Props) {
  const { workedShiftData } = props;

  return (
    <div className={classNames("table", { invisible: !workedShiftData })}>
      <div className="table-header-name" style={{ width: "100%" }}>
        <FontAwesomeIcon icon="clock" /> Timesheet Summary
      </div>

      <table className="w-full">
        <thead>
          <tr>
            <th className="table-header-column-name">Ordinary</th>
            <th className="table-header-column-name">Weekend</th>
            <th className="table-header-column-name">Total</th>
            <th className="table-header-column-name">TOIL accrual</th>
            <th className="table-header-column-name">Allowances</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="table-body-cell">
              {workedShiftData && <OrdinaryHoursSummary summary={workedShiftData.summary} />}
            </td>
            <td className="table-body-cell">
              {workedShiftData && <WeekendHoursSummary summary={workedShiftData.summary} />}
            </td>
            <td className="table-body-cell">
              {workedShiftData && workedShiftData.summary.worked.total > 0 && (
                <Duration seconds={workedShiftData.summary.worked.total} />
              )}
            </td>
            <td className="table-body-cell">
              {workedShiftData && workedShiftData.summary.toil_accrual > 0 && (
                <Duration seconds={workedShiftData.summary.toil_accrual} />
              )}
            </td>
            <td className="table-body-cell">
              {workedShiftData && <AllowanceSummary summary={workedShiftData.summary} />}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
